import React, { useEffect, useState } from "react";
import { Card, Col, Row, Form, Button } from "react-bootstrap";
import {
  ArrowsAngleExpand,
  ArrowsAngleContract,
  ArrowsFullscreen,
  FullscreenExit,
  ArrowsCollapse,
  ArrowsCollapseVertical,
  ArrowsExpandVertical,
  ArrowBarLeft,
  ArrowBarRight,
} from "react-bootstrap-icons";
import "./CardComponent.css";

export const CardComponent = React.memo(
  ({
    title,
    subtitle,
    icon,
    toggle,
    onToggle,
    children,
    isExpanded,
    onExpand,
  }) => {
    const [expandedState, setExpanded] = useState(isExpanded);

    useEffect(() => {
      setExpanded(isExpanded);
    }, [isExpanded]);

    return (
      <Col
        id="columnpanel"
        className="card-component"
        style={{ height: "100%" }}
        sm={{ span: 12, offset: 0 }}
        md={{ span: 12, offset: 0 }}
        lg={{ span: 12, offset: 0 }}
        xl={{ span: 12, offset: 0 }}
        xxl={{ span: 12, offset: 0 }}
      >
        <Card style={{ height: "100%", background: "transparent" }}>
          <Card.Header
            as="h5"
            style={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}
          >
            <Row className="p-0 m-0 g-0">
              <Col className="d-flex align-items-center justify-content-start">
                {icon && <img id="cardicon" src={icon} alt="icon" />}
                <div>
                  <div>{title}</div>
                  {subtitle && (
                    <>
                      <small
                        className="text-muted"
                        style={{ fontSize: "0.75rem", display: "block" }}
                      >
                        {subtitle}
                      </small>
                    </>
                  )}
                </div>
              </Col>
              {typeof toggle !== "undefined" && (
                <Col className="d-flex align-items-center justify-content-end">
                  <Form.Check
                    type="switch"
                    aria-label="radio 2"
                    onChange={onToggle}
                    checked={toggle}
                  />
                </Col>
              )}
              {typeof onExpand !== "undefined" && (
                <Col className="d-flex align-items-center justify-content-end col-auto">
                  <Button
                    // style={{width:35,height:35,borderRadius:5}}
                    className="expandable"
                    variant="outline-warning"
                    size="sm"
                    title="Expand/Collapse events details"
                    onClick={(e) => {
                      setExpanded(!expandedState);
                      onExpand && onExpand(!expandedState);
                    }}
                  >
                    {expandedState ? (
                      <ArrowBarLeft className="scale-up" size={22} />
                    ) : (
                      <ArrowBarRight className="scale-up" size={22} />
                    )}
                  </Button>
                </Col>
              )}
            </Row>
          </Card.Header>
          <Card.Body
            style={{ borderBottomLeftRadius: 10, borderBottomRightRadius: 10 }}
          >
            {children}
          </Card.Body>
        </Card>
      </Col>
    );
  }
);
